import { Box } from "@mui/joy";
import { useParams } from "react-router-dom";

import { Gate } from "../../../../../../shared";
import { PERMISSIONS } from "../../../../../../constants/permissions";
import { useProject as useProjectQuery } from "../../../../../../hooks/query";
import { DangerZone } from "./DangerZone";

export default function Settings() {
    const params = useParams();
    const projectId = params.id as string;

    const { useGetProjectById } = useProjectQuery();
    const { data: projectDetails } = useGetProjectById(projectId);

    return (
        <Box maxWidth={860} pb={4} pl={2}>
            <Gate anyOf={[PERMISSIONS.PROJECT_MANAGE]}>
                <DangerZone
                    projectId={projectId}
                    projectName={projectDetails?.Name}
                />
            </Gate>
        </Box>
    );
}
